import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'antd';
import { getRequestErrorMessage } from '@/utils/requestError';
import './index.scss';

const mib = bytes => (bytes / 1024 / 1024).toFixed(1);
const selectionSize = bytes => bytes === 0 ? '0.0 MB' : bytes < 1024 ? `${bytes} B` : bytes < 1024 * 1024 ? `${(bytes / 1024).toFixed(1)} KB` : `${mib(bytes)} MB`;
const ImageQuota = ({ fetchQuota, version = 0, selectedFiles, showAccountQuota = true }) => {
  const [quota, setQuota] = useState(null); const [error, setError] = useState(''); const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!showAccountQuota) return;
    let active = true;
    fetchQuota().then(data => { if (active) { setQuota(data); setError(''); } })
      .catch(err => { if (active) setError(getRequestErrorMessage(err, '图片容量加载失败')); });
    return () => { active = false; };
  }, [fetchQuota, version, retry, showAccountQuota]);
  const files = Array.isArray(selectedFiles) ? selectedFiles : [];
  const selectedBytes = files.reduce((total, file) => {
    const size = Number(file.originFileObj?.size ?? file.size ?? 0);
    return total + (Number.isFinite(size) && size > 0 ? size : 0);
  }, 0);
  const showSelection = selectedFiles !== undefined;
  return <div className="imageQuota">
    {showSelection && <p className="imageQuota-selection" role="status" aria-live="polite">本次已选 {files.length} 张图片 · 共 {selectionSize(selectedBytes)}</p>}
    {showAccountQuota && (error ? <Alert type="warning" title={error} action={<Button size="small" onClick={() => setRetry(n => n + 1)}>重试</Button>} />
      : quota && <p className="imageQuota-account">{showSelection ? '账号已上传图片' : '图片已用'} {mib(quota.used_bytes)} MB{quota.is_exempt ? ' · 不限总容量' : ` / ${mib(quota.limit_bytes)} MB，剩余 ${mib(quota.remaining_bytes)} MB`}{!showSelection && ' · 单张最多 5 MB'}</p>)}
  </div>;
};
export default ImageQuota;
